<work-view
  [backlogTasks]="backlogTasks()"
  [doneTasks]="doneTasks()"
  [isShowBacklog]="false"
  [undoneTasks]="undoneTasks()"
></work-view>
